module.exports = __webpack_public_path__ + "static/media/hourglass.c4b1b4d3.png";